import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import cx from 'classnames';

const propTypes = {
  service: PropTypes.object,
};

const PaymentHolidaySection = ({ service = {} }) => {
  const serviceClasses = cx({
    'additional-service': true,
    'additional-service--short': true,
    'additional-service--payment-holiday-icon': true,
    'additional-service--available': service.enabled || service.isAvailable,
  });

  return (
    <div className="content-block">
      <div className={serviceClasses}>
        <div className="additional-service__heading">
          <FormattedMessage id="selfservice.paymentHoliday.heading.title" tagName="h3" />
        </div>
        {service.enabled
          ? (
            <>
              <p className="additional-service__description">
                <FormattedMessage id="selfservice.paymentHoliday.description.active" />
              </p>
              <nav className="additional-service__bottom-nav">
                <span className="additional-service__active additional-service__active--small">
                  <FormattedMessage id="selfservice.paymentHoliday.active" />
                </span>
                <Link to="/other-services">
                  <FormattedMessage id="selfservice.paymentHoliday.infoLink" />
                </Link>
              </nav>
            </>
          )
          : (
            <>
              <p className="additional-service__description">
                <FormattedMessage id="selfservice.paymentHoliday.description" />
              </p>
              <nav className="additional-service__bottom-nav">
                <Link to="/other-services">
                  <FormattedMessage id="selfservice.dashboard.more" />
                </Link>
              </nav>
            </>
          )}
      </div>
    </div>
  );
};

PaymentHolidaySection.propTypes = propTypes;

export default PaymentHolidaySection;
